import useSWR from "swr";

import { SalesPerformanceData } from "@/interfaces/sales-performace.interfaces";
import salesDashboardService from "@/services/sales-dashboard.service";

export interface UseGetSalesPerformanceProps {
  startDate: string;
  endDate: string;
}

export type UseGetSalesPerformanceReturn = {
  data: SalesPerformanceData | null;
  isLoading: boolean;
  error: Error | null;
};

const useGetSalesPerformance = ({
  startDate,
  endDate,
}: UseGetSalesPerformanceProps): UseGetSalesPerformanceReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR(
    ["getSalesPerformance", startDate, endDate],
    () => salesDashboardService.salesPerformance(startDate, endDate),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetSalesPerformance;
